const React = require('react');
const CaptionC = require('../../../dumb/Caption/C');


module.exports = () => {
  return (
    <div>
      <div className="layoutRow fhaB fvaC">
        <CaptionC>Lunu Support</CaptionC>
      </div>
    </div>
  );
};
